import { useState } from 'react'
import { SortingArrows, SortingIcon } from '../../icons'
import { flexRender, type Table } from '@tanstack/react-table'
import Card from '../Card'

export function GenericTableMobileSortButton<T>({ table }: { table: Table<T> }) {
  const [isOpen, setIsOpen] = useState(false)

  const sortableColumns = table.getAllColumns().filter((column) => column.getCanSort())

  if (sortableColumns.length === 0) return null

  const currentSort = table.getState().sorting[0]

  return (
    <div className="relative flex justify-end my-2">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 p-3 bg-white border border-borderGray rounded-sm text-sm font-medium text-primaryBlue hover:bg-grayLight"
      >
        <SortingIcon />
      </button>

      {isOpen && (
        <>
          <button
            type="button"
            className="fixed inset-0 z-10 cursor-default"
            onClick={() => setIsOpen(false)}
            onKeyDown={(e) => e.key === 'Escape' && setIsOpen(false)}
            aria-label="Close sort menu"
          />
          <Card className="absolute top-full right-0 mt-2 w-64 bg-white z-20 max-h-80">
            {sortableColumns.map((column) => {
              const isSorted = currentSort?.id === column.id
              const isDesc = isSorted && currentSort.desc

              return (
                <div key={column.id} className="border-b border-borderGray last:border-b-0">
                  <button
                    type="button"
                    onClick={() => {
                      if (isSorted) {
                        if (isDesc) {
                          column.clearSorting()
                        } else {
                          column.toggleSorting(true)
                        }
                      } else {
                        column.toggleSorting(false)
                      }
                      setIsOpen(false)
                    }}
                    className="w-full px-4 py-3 text-left hover:bg-grayLight flex items-center justify-between"
                  >
                    <span className="text-sm text-primaryText">{flexRender(column.columnDef.header, {} as any)}</span>
                    {isSorted && (
                      <span className="text-sm font-medium text-primaryBlue ">
                        {isDesc ? (
                          <span className="flex flex-row gap-1">
                            <span className="scale-75">
                              <SortingArrows sorting="desc" />
                            </span>
                            desc
                          </span>
                        ) : (
                          <span className="flex flex-row gap-1">
                            <span className="scale-75">
                              <SortingArrows sorting="asc" />
                            </span>
                            asc
                          </span>
                        )}
                      </span>
                    )}
                  </button>
                </div>
              )
            })}
          </Card>
        </>
      )}
    </div>
  )
}
